export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://zmaonline.in/api';
// export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
// export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081/api';


